export type PageKey = "home" | "pricing" | "docs" | "terms" | "privacy" | "dashboard" | "login" | "unlock" | "invite" | "authorizeCode" | "notFound";

export const routeRegistry: Record<string, PageKey> = {
  "/": "home",
  "/pricing": "pricing",
  "/terms": "terms",
  "/privacy": "privacy",
  "/docs": "docs",
  "/docs/access-grants": "docs",
  "/docs/first-admin-authorized-device": "docs",
  "/docs/workspace-roles": "docs",
  "/docs/project-assignments": "docs",
  "/docs/channel-grants": "docs",
  "/docs/public-pull-cdn": "docs",
  "/docs/deploy-status": "docs",
  "/dashboard": "dashboard",
  "/dashboard/keyfiles": "dashboard",
  "/dashboard/keys": "dashboard",
  "/dashboard/members": "dashboard",
  "/dashboard/channels": "dashboard",
  "/dashboard/machines": "dashboard",
  "/dashboard/audit": "dashboard",
  "/dashboard/billing": "dashboard",
  "/login": "login",
  "/unlock": "unlock",
  "/authorize-code": "authorizeCode"
};

export function resolveRoute(pathname: string): PageKey {
  if (pathname.startsWith("/invite/")) return "invite";
  return routeRegistry[pathname] ?? "notFound";
}

export function docHref(title: string) {
  if (title === "Access grants and encrypted access updates") return "/docs/access-grants";
  if (title === "First admin Authorized Device") return "/docs/first-admin-authorized-device";
  if (title === "Workspace roles") return "/docs/workspace-roles";
  if (title === "Project assignments") return "/docs/project-assignments";
  if (title === "Channel grants") return "/docs/channel-grants";
  if (title === "Public encrypted pull CDN") return "/docs/public-pull-cdn";
  if (title === "Deploy status and CDN refresh") return "/docs/deploy-status";
  return "/docs";
}
